import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { format } from 'date-fns';

function Bet(props) {
    let { bet } = props;
    let statusStyle = 'bl-red-8';

    if (bet.settlement === null) {
        statusStyle = 'bl-gray-8';
    } else if (bet.settlement === 2) {
        statusStyle = 'bl-green-8';
    }

    let stakeInfo = bet.settlement === 2 ? 'Stake:' + parseFloat(bet.stake).toFixed(2) : '';
    let winInfo = bet.settlement === 2 ? 'Win:' + parseFloat(bet.win).toFixed(2) : '';

    return (
        <div>
            <div className={'pb-1 fs-13 p-0 pl-2 pr-2 pt-2 pb-2' + statusStyle}>
                <Row className="m-0 p-0 pr-2 pl-2">
                    <Col xs={8} className="p-0 pt-1 text-gray font-100">
                        Championsleague CUP
                    </Col>
                    <Col xs={2} className="p-0 pt-1 text-center"></Col>
                    <Col xs={2} className="p-0 pt-1 text-right">
                        <i className="icon-live fs-15 bg-live" style={{ marginRight: '10px' }}></i>
                    </Col>
                </Row>
                <Row className="m-0 p-0 pr-2 pl-2">
                    <Col xs={8} className="p-0 pt-1 font-600">
                        {bet.match}
                    </Col>
                    <Col xs={2} className="p-0 pt-1 text-center text-green fs-15">
                        0 : 0
                    </Col>
                    <Col xs={2} className="p-0 pt-1 text-right fs-15">
                        {parseFloat(bet.price).toFixed(2)}
                    </Col>
                </Row>
                <Row className="m-0 p-0 pr-2 pl-2">
                    <Col xs={4} className="p-0 pt-1">
                        <time>{format(bet.start_date, 'dd/MM/yy')}</time>
                        <span>&nbsp;</span>
                        <time>{format(bet.start_date, 'kk:mm')}</time>
                    </Col>
                    <Col xs={4} className="p-0 pt-1 text-center text-green"></Col>
                    <Col xs={4} className="p-0 pt-1 text-right">
                        {stakeInfo}
                    </Col>
                </Row>
                <Row className="m-0 p-0 pr-2 pl-2">
                    <Col xs={2} className="p-0 pt-1 font-600 text-green">
                        Pick {bet.name}
                    </Col>
                    <Col xs={6} className="p-0 pt-1 text-green">
                        Rest of the match
                    </Col>
                    <Col xs={4} className="p-0 pt-1 text-right">
                        {winInfo}
                    </Col>
                </Row>
            </div>
            <div className="cashout-divider"></div>
        </div>
    );
}

export default Bet;
